import {createContext} from 'react';


const tareaContex = createContext();


export default tareaContex;